module.exports = __webpack_public_path__ + "static/img/tutorial-normal-attraction-2.4846187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-normal-attraction-2.jpg
// module id = Ut5Q
// module chunks = 3